<template>
    <v-row>
        <v-col cols="12" class="text-h6 kbDarkBlue--text">
            Tickets
        </v-col>

        <v-col cols="12">
            <v-select @change="$emit('updateCurrency', $event)"
                      color="kbDarkBlue"
                      item-text="label"
                      item-value="value"
                      :items="currencies"
                      :label="$t('general.eventCurrency')"
                      :rules="[rules.required]"
                      :value="currency">
            </v-select>
        </v-col>

        <v-col cols="12" v-for="(ticket, index) in value" :key="ticket.key">
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-select :label="$t('general.type')"
                                      color="kbDarkBlue"
                                      :items="typeTickets"
                                      item-text="value"
                                      return-object
                                      v-model="ticket.type"
                                      @change="ticket.servicePrice = 0">
                            </v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field :label="$t('general.ticketTitle')"
                                          color="kbDarkBlue"
                                          v-model="ticket.title">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" v-if="ticket.type.code === 1">
                            <v-text-field :label="$t('general.ticketPrice')"
                                          color="kbDarkBlue"
                                          v-model="ticket.price">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" v-if="ticket.type.code === 1">
                            <v-text-field :label="$t('general.ticketingServicePrice')"
                                          color="kbDarkBlue"
                                          v-model="ticket.servicePrice">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <DateTimePicker v-model="ticket.saleFrom"
                                            :min="minDate()"
                                            @click:clear="ticket.saleUntil = ''"
                                            :label="$t('general.startOfSale')">
                            </DateTimePicker>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <DateTimePicker v-model="ticket.saleUntil"
                                            :min="minDateUntil(ticket.saleFrom)"
                                            :label="$t('general.endOfSale')"
                                            :disabled="!ticket.saleFrom">
                            </DateTimePicker>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <DateTimePicker v-model="ticket.accessFrom"
                                            :min="minDate()"
                                            @click:clear="ticket.accessUntil = ''"
                                            :label="$t('general.startDateAccess')">
                            </DateTimePicker>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <DateTimePicker v-model="ticket.accessUntil"
                                            :min="minDateUntil(ticket.accessFrom)"
                                            :label="$t('general.finishDateAccess')"
                                            :disabled="!ticket.accessFrom">
                            </DateTimePicker>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field :label="$t('general.ticketsNumber')"
                                          color="kbDarkBlue"
                                          v-model="ticket.quantity">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field :label="$t('general.maxTicketsPerPerson')"
                                          color="kbDarkBlue"
                                          v-model="ticket.maxPerClient">
                            </v-text-field>
                        </v-col>

                        <v-col class="text-right" cols="12" v-if="!isEditingEvent">
                            <v-btn color="error" @click="deleteTicket(index)" rounded>{{$t('general.deleteTicket')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <v-btn color="kbGold" dark rounded @click="addTicket()">{{$t('general.addTicket')}}</v-btn>
        </v-col>
    </v-row>
</template>

<script>
import DateTimePicker from '@/components/ui/DateTimePicker'
import moment from 'moment'
import rules from '@/libs/rules'
import typeTickets from '@/libs/typeTickets'
import uniqid from 'uniqid'
export default {
  components: { DateTimePicker },
  created () {
    if (this.value.length === 0) {
      this.addTicket()
    }
  },
  data () {
    return {
      currencies: [
        { label: 'COP', value: 'cop' },
        { label: 'USD', value: 'usd' }
      ],
      rules,
      ticket: {
        key: '',
        type: '',
        saleFrom: '',
        saleUntil: '',
        price: '',
        servicePrice: '',
        title: '',
        maxPerClient: '',
        quantity: '',
        menuSaleFrom: false,
        menuSaleUntil: false
      },
      typeTickets
    }
  },
  methods: {
    addTicket () {
      this.ticket.key = uniqid()
      this.ticket.saleFrom = moment().format('YYYY-MM-DD hh:mm')
      if (this.eventStartsAt) {
        this.ticket.accessFrom = this.eventStartsAt
      }
      if (this.eventEndsAt) {
        this.ticket.saleUntil = this.eventEndsAt
        this.ticket.accessUntil = this.eventEndsAt
      }
      this.value.push(JSON.parse(JSON.stringify(this.ticket)))
    },
    deleteTicket (index) {
      if (this.value.length > 0) {
        this.value.splice(index, 1)
      }
    },
    minDate () {
      return moment().format('YYYY-MM-DD')
    },
    minDateUntil (date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD')
      }
    }
  },
  props: ['currency', 'eventEndsAt', 'eventStartsAt', 'isEditingEvent', 'value']
}
</script>
